import { cartLinesListHeaderStyles } from "@insite/content-library/Components/CartLinesListHeader";
import { css } from "styled-components";

cartLinesListHeaderStyles.condensedCheckbox = {
    css: css`
        display: none;
    `,
}